import React from "react";

export default function App(){
    return (
        <div className="spinner-wrapper">
            <div className="spinner-custom"></div>
        </div>
    )
}